import { HttpError } from '@/api/client'

const KNOWN = [
  'INVALID_CONTAINER_NUMBER',
  'EXPORT_NOT_ENABLED',
  'EMPTY_RETURN_INCOMPLETE',
  'ILLEGAL_TRANSITION',
  'CUSTOMER_NOT_FOUND',
  'CUSTOMER_REQUIRED',
  'CARRIER_NOT_FOUND',
  'COMPANY_NOT_FOUND',
  'COMPANY_MODE_MISMATCH',
  'COMPANY_CODE_TAKEN',
  'UNKNOWN_LOCATION',
  'MODES_REQUIRED',
  'INVALID_COMPANY_CODE',
  'INVALID_COMPANY_NAME',
  'INVALID_COUNTRY',
  'INVALID_LEGAL_NAME',
  'INVALID_SCAC',
  'INVALID_IATA',
  'INVALID_CURRENCY',
  'INVALID_PAYMENT_TERMS',
  'INVALID_CREDIT_DAYS',
  'INVALID_WEBSITE',
  'INVALID_NOTES',
  'INVALID_CONTACT_ROLE',
  'INVALID_CONTACT_NAME',
  'INVALID_EMAIL',
  'INVALID_PHONE',
  'INVALID_CITY',
  'CHARGE_MODE_MISMATCH',
  'BASIS_MODE_MISMATCH',
  'INVALID_EQUIPMENT',
  'RULE_MODE_MISMATCH',
  'INVALID_AMOUNT',
  'INVALID_DATE_RANGE',
  'INVALID_RULE_VALUE',
  'CONTAINER_ALREADY_ON_FILE',
  'INVALID_BODY',
  'INVALID_DATE',
  'NOT_LCL',
  'NOT_OPEN',
  'SEALED',
  'CLOSED',
  'CUTOFF_PASSED',
  'ALREADY_ATTACHED',
  'DIRECTION_MISMATCH',
  'DANGEROUS_GOODS',
  'CAPACITY_EXCEEDED',
  'NO_HOUSES',
  'MEASURES_REQUIRED',
  'HOUSE_WITHOUT_MEASURES',
  'CONTAINER_REQUIRED',
  'MBL_REQUIRED',
  'EQUIPMENT_REQUIRED',
  'CONTAINER_ON_LCL',
  'INVALID_COST_TYPE',
  'SUPPLIER_NOT_FOUND',
  'INVALID_SERVICE',
  'INVALID_MEASURE',
]

export function freightErrorMessage(t: (key: string) => string, err: unknown) {
  if (!(err instanceof HttpError)) return t('errors.generic')
  const token = KNOWN.find((code) => err.message.includes(code))
  return token ? t(`errors.${token}`) : err.message || t('errors.generic')
}

export function formatWhen(iso: string | null | undefined, locale: string) {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(date)
}

export function formatMoney(cents: number, currency: string, locale: string) {
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100)
  } catch {
    return `${cents / 100} ${currency}`
  }
}

export function dateInputValue(iso: string | null | undefined) {
  if (!iso) return ''
  return iso.slice(0, 10)
}
